var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDentCallSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5805 14.5704L14.343 17.7954H14.068C12.6723 17.4941 11.3287 16.9887 10.0805 16.2954C8.84718 15.631 7.71842 14.7886 6.73047 13.7954C4.71196 11.7747 3.34117 9.1985 2.79297 6.39543V6.10793L5.94297 2.94543L9.30547 6.27043L7.45547 8.12043C7.61749 8.45459 7.79691 8.78004 7.99297 9.09543L7.23047 9.85793C6.88467 9.33855 6.58359 8.79075 6.33047 8.22043L6.18047 7.94543L7.79297 6.27043L5.94297 4.40793L3.89297 6.45793C4.15703 7.64965 4.57733 8.80128 5.14297 9.88293C5.76864 11.0456 6.56028 12.1109 7.49297 13.0454C8.4062 13.9654 9.45091 14.7447 10.593 15.3579C11.6729 15.9276 12.825 16.3481 14.018 16.6079L16.0805 14.5329L14.2305 12.7079L12.5805 14.3329L12.268 14.1954C10.9828 13.6108 9.8172 12.7928 8.83047 11.7829C8.59251 11.5449 8.3672 11.2946 8.15547 11.0329L8.90547 10.2829C9.1172 10.5446 9.34251 10.7949 9.58047 11.0329C10.4115 11.8614 11.3747 12.5457 12.4305 13.0579L14.2305 11.1954L17.5805 14.5704Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDentCallSmall);
export default __webpack_public_path__ + "static/media/DentCallSmall.e243e06c405ea060862b7c25acaa107e.svg";
export { ForwardRef as ReactComponent };